
/**
 * Converts Object.entries() back into an object
 * @param {array} arr Array of object entries
 * @param {object} obj Object to extend (optional)
 *
 * @example
 *
 * const arr = Object.entries(myObj).map(([key, val]) => {
 *      return [key, val * 2];
 * })
 *
 * const myNewObject = entriesToObject(arr);
 */
export const entriesToObject = (arr, obj = {}) => arr.reduce((acc, [k, v]) => {

    acc[k] = v;

    return acc;
}, obj);

/**
 *
 * @param {*} value Value to validate again
 * @param {*} validator Validator function or regular expression
 * @param {*} rgxFn indicate whether to match or test
 */
export const resolveValidation = (value, validator, rgxFn = 'test') => {

    if (validator.constructor === Function) {

        return validator(value);
    }

    if (validator.constructor === RegExp) {

        if (rgxFn === 'test') {

            return validator.test(value);
        }
        if (rgxFn === 'match') {

            return !!value.match(validator);
        }
    }

    throw new TypeError('validator must be a Function or RegExp');
};

/**
 * Creates a promise that resolves in X time
 * @param {integer} time time in ms to wait
 */
export const wait = time => new Promise(res => setTimeout(res, time));


export const mapToId = (payload, identifier = 'id') => Object.values(payload || {})
    .reduce((a, c) => ({
        ...a,
        [c[identifier]]: c
    }), {});


export const getExtension = filename => {
    const parts = filename.split('.');

    return parts[parts.length - 1];
};
